module.exports = __webpack_public_path__ + "img/aepx.93f14259.svg";